import React from "react";
import { useTranslation } from "react-i18next";
import { Info, AlertTriangle, ShieldAlert } from "lucide-react";

/**
 * SeverityBadge — calm severity indicator.
 *
 * Phase 4 directive #5: "Critical cards should feel visually elevated but
 * NEVER alarming/red-danger enterprise cliché." We use calm dark-blue for
 * critical and quiet greys for the rest.
 */
export const SeverityBadge = ({ severity = "info", className = "" }) => {
    const { t } = useTranslation();
    const map = {
        info: { icon: Info, color: "var(--ob-text-tertiary)", bg: "rgba(255,255,255,0.04)", label: "ob.activity.severity.info" },
        attention: { icon: AlertTriangle, color: "#93C5FD", bg: "rgba(59,130,246,0.10)", label: "ob.activity.severity.attention" },
        critical: { icon: ShieldAlert, color: "#FCA5A5", bg: "rgba(239,68,68,0.10)", label: "ob.activity.severity.critical" },
    };
    const cfg = map[severity] || map.info;
    const Icon = cfg.icon;
    return (
        <span
            data-testid={`ob-severity-${severity}`}
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs ${className}`}
            style={{
                background: cfg.bg,
                color: cfg.color,
                border: `1px solid ${cfg.color}30`,
            }}
        >
            <Icon size={12} strokeWidth={1.5} aria-hidden="true" />
            <span>{t(cfg.label)}</span>
        </span>
    );
};
